export function currency(value: any, showNull: boolean) {
    if (value === null && showNull) {
        return "-";
    }

    if (typeof value !== "number") {
        return value;
    }
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
    });
    return formatter.format(value);
}
